export default __webpack_public_path__ + "static/media/mq.73ac26cd.jpg";